import { APIS } from '@/constants';
import wsBackendHandler from './wsBackendHandler';

let client;

const wsBackendClient = {
  get() {
    if (!client) {
      _init();
    }
    return client;
  },
};

export default wsBackendClient;

const _init = () => {
  // Skip WebSocket initialization if URL is not configured
  if (!APIS.WS.URL_BACKEND) {
    console.error(
      'Backend WebSocket URL not configured. Skipping backend WebSocket connection.'
    );
    client = null;
    return;
  }

  let connected = false;

  try {
    client = new WebSocket(APIS.WS.URL_BACKEND);

    client.onopen = function () {
      if (!connected) {
        connected = true;
      }
    };

    client.onmessage = function (evt) {
      try {
        wsBackendHandler.onMessage(evt);
      } catch (error) {
        console.error('Error handling backend WebSocket message:', error);
      }
    };

    client.onerror = function (evt) {
      console.error('Backend WebSocket error:', evt);
    };

    client.onclose = function () {
      connected = false;
    };
  } catch (error) {
    console.error('Failed to initialize backend WebSocket:', error);
    client = null;
  }
};
